// src/Components/Admin/AdminLandingPage.jsx
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { OptionsProvider } from './contexts/OptionsContext';
import Layout from './components/Layout';
import Dashboard from './components/Dashboard';
import Students from './pages/Students';
import StudentFeedback from './pages/StudentFeedback';
import Assessments from './pages/Assessments';
import AssessmentDetail from './pages/AssessmentDetail';
import Account from './pages/Account';
import './admin-tailwind.css';
import './admin-theme.css';

const AdminLandingPage = () => {
  return (
    <div className="admin-wrapper"> 
    <OptionsProvider>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Navigate to="students" replace />} />
          <Route path="students" element={<Students />} />
          <Route path="feedback" element={<StudentFeedback />} />
          {/* <Route path="assessments" element={<Assessments />} /> */}
          {/* <Route path="assessments/:assessmentId" element={<AssessmentDetail />} /> */}
          <Route path="account" element={<Account />} />
        </Route>
      </Routes>
    </OptionsProvider>  
    </div>
  );
};

export default AdminLandingPage;